/**
 * Public API for FGA Manager models
 *
 * This barrel file re-exports all model interfaces and types
 * for easy importing from '@platform-auth/fga-manager'.
 *
 * @packageDocumentation
 */

// Group models
export type {
  FgaGroup,
  FgaGroupsResponse,
  FgaGroupUsersResponse,
  ParsedGroupId
} from './group.model';

export {
  parseGroupId,
  buildGroupId,
  isScimManagedGroupId,
  SCIM_GROUP_ID_PATTERN,
  SCIM_GROUP_PREFIX,
} from './group.model';

// User models
export type {
  FgaUser,
  FgaUsersResponse,
  FgaUserGroupsResponse,
  ParsedUserId,
  IdentityProvider
} from './user.model';

export { parseUserId, buildUserId } from './user.model';

export type { EntityType, IdentityType, MembershipMode } from './entity.model';

export { ENTITY_TYPE, MEMBERSHIP_MODE } from './entity.model';

// FGA Constants and utilities
export {
  FGA_USER_PREFIX,
  FGA_GROUP_PREFIX,
  FGA_ORGANIZATION_PREFIX,
  createFgaUserId,
  createFgaGroupId,
  createFgaOrganizationId,
  isM2MClientUserId,
  extractM2MClientId
} from './fga-constants';

// Auth0 User models (for enrichment)
export type {
  Auth0UserProfile,
  EnrichedUser,
  Auth0UserBatchResponse,
  Auth0UserSearchResult
} from './auth0-user.model';

export { fgaToAuth0UserId } from './auth0-user.model';

// M2M Client models
export type {
  M2MClient,
  M2MClientsResponse,
  M2MClientServiceConfig
} from './m2m-client.model';

// API models
export type {
  TokenResponse,
  FgaMembership,
  FgaErrorResponse,
  FgaErrorEvent,
  ApiHttpError,
  GroupSelectedEvent,
  UserSelectedEvent,
  DataChangedEvent,
  FgaManagerConfig,
  GroupState,
  UserState
} from './api.model';

export { FGA_ERROR_CODES } from './api.model';

// Log event models
export type { LogLevel, LogEvent } from './log-event.model';
export { LOG_LEVEL_PRIORITY } from './log-event.model';

// Auth0 Organization models (for organization members feature)
export type {
  Auth0OrgMember,
  Auth0OrgServiceConfig,
  LoadMembersOptions,
  OrgMembersResponse,
  OrgMemberCheckpointResponse,
  OrgMemberRaw,
  DataSource
} from './auth0-org.model';
